module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/120.ecf4f3dc.png";